export default {
  FETCH_SUMMARY_QUESTIONS_BEGIN: 'FETCH_SUMMARY_QUESTIONS_BEGIN',
  FETCH_SUMMARY_QUESTIONS_SUCCESS: 'FETCH_SUMMARY_QUESTIONS_SUCCESS',
  FETCH_SUMMARY_QUESTIONS_FAILURE: 'FETCH_SUMMARY_QUESTIONS_FAILURE'
};